module.exports = __webpack_public_path__ + "img/venue-gray-3.882f980c.png";